define('app/editor/AlertPage',['require','./ReportPage','./dialogs/EditAlertDialogView','./dialogs/SaveAlertDialogView','glu/dialog','app/app','hbs!./AlertPage.hbs'],function(require) {
	'use strict';

	var ReportPage = require('./ReportPage'),
		EditAlertDialogView = require('./dialogs/EditAlertDialogView'),
		SaveAlertDialogView = require('./dialogs/SaveAlertDialogView'),
		dialog = require('glu/dialog'),
		App = require('app/app');

	var noDesc = '(No description)';

	var minuteStr = 'minutes';
	var hourStr = 'hours';
	var dayStr = 'days';

	return ReportPage.extend({

		template: require('hbs!./AlertPage.hbs'),

		events: {
			'click #toggle-report-definition-button': 'toggleReportDefinition',
			'click [data-qa="report-save"]': 'save',
			'click .alert-save-as': 'saveAs',
			'click [data-qa="report-rename"]': 'rename',
			'click .report-edit-alert': 'editAlert',
			'click [data-qa="report-delete"]': 'delete',
			'click .toggle-description': 'toggleDescription',
			'click .no-columns-message a, .no-columns-message button': 'openAddColumnDialog',
			'blur .report-name': 'updateReportName',
			'keydown .report-name': 'reportNameKeyEvents',
			'blur .description span': 'updateReportDescription',
			'focus .description span': 'clearReportDescription',
			'keydown .description span': 'reportDescriptionKeyEvents'
		},

		initialize: function() {
			// call base class initialize function
			ReportPage.prototype.initialize.call(this);

			var self = this;

			this.listenTo(this.model, 'change:setSelectedCell', function(isChangedColumn) {
				if (isChangedColumn && self.isValidDonut()) {
					self.dialog.open(new EditAlertDialogView({
						model: self.model,
						className: 'modal-edit-alert',
						blankValues: true,
						isChangedColumn: true
					}));
				}
			});

			this.listenTo(this.model, 'change:alert:invalidate', function() {
				self.model.run();
				self.renderResults();
			});
		},

		refreshClassesAndStates: function() {
			// call base class initialize function
			ReportPage.prototype.refreshClassesAndStates.call(this);

			var threshold = this.model.getThreshold();
			if (threshold) {
				this.$el.find('.follow').html('<i class="icon-clock"></i>' + this.getThresholdLabel(threshold));
				this.$el.find('.follow').show();
			} else {
				this.$el.find('.follow').html('');
				this.$el.find('.follow').hide();
			}

			if (!this.isValidDonut()) {
				this.$el.find('.alert-save-as').addClass('disabled');
				this.$el.find('.alert-save-as').parent().addClass('disabled');
			} else {
				this.$el.find('.alert-save-as').removeClass('disabled');
				this.$el.find('.alert-save-as').parent().removeClass('disabled');
			}
		},

		save: function(e) {
			var self = this;
			//var payload;

			e.preventDefault();

			// Save is not allowed for internal users
			if (App.user.isInternalUser()) {
				return;
			}

			if ((self.model.isDirty() && self.model.isOwner()) && self.model.isValid() && self.isValidDonut()) {
				self.model.set('saveInProgress', true, {
					silent: true
				});

				if (self.model.getDescription() === noDesc) {
					self.model.set('description', '', {
						silent: true
					});
				}

				self.model.saveAsIs().then(function() {
					self.model.set('saveInProgress', false, {
						silent: true
					});
				});

				self.model.setAlert(self.model.getThreshold()).then(function() {
					self.model.trigger('alertSet');
				});

				self.model.clean();

				self.refreshClassesAndStates();

			} else {
				dialog.error('The report is not a valid donut widget at the moment. You cannot save the alert!');
			}
		},

		saveAs: function(e) {
			var self = this;
			e.preventDefault();

			if (this.model.getDescription() === noDesc) {
				this.model.set('description', '', {
					silent: true
				});
			}

			if (self.model.isRunnable()) {
				this.dialog.open(new SaveAlertDialogView({
					model: this.model,
					className: 'modal-save-report',
					saveAs: true,
					noname: true,
					callback: self.onSaveAs
				}));
			}
		},

		editAlert: function(e) {
			var self = this;
			e.preventDefault();
			// Make sure menu item isn't disabled

			this.dialog.open(new EditAlertDialogView({
				model: self.model,
				className: 'modal-edit-alert'
			}));
		},

		getThresholdLabel: function(threshold) {
			var label = '';
			if (threshold) {
				this.formatTimespan(threshold);
				if (threshold.range === 'LOW') {
					label = 'Below' + ' ' + threshold.formattedVal1;
					if (threshold.timeUnit1) {
						label += ' ' + threshold.timeUnit1;
					}
				} else if (threshold.range === 'HIGH') {
					label = 'Above' + ' ' + threshold.formattedVal1;
					if (threshold.timeUnit1) {
						label += ' ' + threshold.timeUnit1;
					}
				} else if (threshold.range === 'IN_RANGE') {
					label = 'Within Range' + ' ' + threshold.formattedVal1;

					if (threshold.timeUnit1) {
						label += ' ' + threshold.timeUnit1;
					}

					label += ' - ' + threshold.formattedVal2;

					if (threshold.timeUnit2) {
						label += ' ' + threshold.timeUnit2;
					}
				} else if (threshold.range === 'OUT_RANGE') {
					label = 'Outside Range' + ' ' + threshold.formattedVal1;

					if (threshold.timeUnit1) {
						label += ' ' + threshold.timeUnit1;
					}

					label += ' - ' + threshold.formattedVal2;

					if (threshold.timeUnit2) {
						label += ' ' + threshold.timeUnit2;
					}
				}
				label += ' - ' + this.getSchedule(threshold);
			}
			return label;
		},

		getSchedule: function(threshold) {
			return threshold.schedule.substr(0, 1).toUpperCase() + threshold.schedule.substr(1).toLowerCase();
		},

		isTimespan: function() {
			// check if the selected column is a timespan
			var selectedColumn = this.model.getSelectedColumn();
			if (selectedColumn) {
				var column = this.model.getColumnByName(selectedColumn);
				if (column && column.getAggregation() !== 'COUNT' && column.getAggregation() !== 'COUNTD' && ((column.get('columnType') === 'FUNCTION' && column.get('type') === 'TIMESPAN') ||
						(column.get('fieldObject') && column.get('fieldObject').get('type') === 'TIMESPAN'))) {
					return true;
				}
			}
			return false;
		},

		formatTimespan: function(threshold) {
			if (threshold.value1 !== undefined && this.isTimespan()) {
				threshold.formattedVal1 = this.formatSeconds(threshold.value1);
				threshold.timeUnit1 = this.getTimeUnit(threshold.formattedVal1);
				threshold.formattedVal1 = threshold.formattedVal1.substring(0, threshold.formattedVal1.length - 1);
			} else {
				threshold.formattedVal1 = threshold.value1;
			}

			if (threshold.value2 !== undefined && this.isTimespan()) {
				threshold.formattedVal2 = this.formatSeconds(threshold.value2);
				threshold.timeUnit2 = this.getTimeUnit(threshold.formattedVal2);
				threshold.formattedVal2 = threshold.formattedVal2.substring(0, threshold.formattedVal2.length - 1);
			} else {
				threshold.formattedVal2 = threshold.value2;
			}

			// check if time unit for 0 is the same as for second value
			if ((threshold.formattedVal1 === 0 || threshold.formattedVal1 === '0') && this.isTimespan()) {
				threshold.timeUnit1 = threshold.timeUnit2;
			}

			if ((threshold.formattedVal2 === 0 || threshold.formattedVal2 === '0') && this.isTimespan()) {
				threshold.timeUnit2 = threshold.timeUnit1;
			}
		},

		formatSeconds: function(seconds) {
			var secondsInAMin = 60;
			var secondsInAnHour = 60 * secondsInAMin;
			var secondsInADay = 24 * secondsInAnHour;

			if (seconds === null || seconds === '') {
				return '';
			}

			if (seconds % secondsInADay === 0) {
				var days = Math.floor(seconds / secondsInADay);
				return days + 'd';
			} else if (seconds % secondsInAnHour === 0) {
				var hours = Math.floor(seconds / secondsInAnHour);
				return hours + 'h';
			} else if (seconds % secondsInAMin === 0) {
				var minutes = Math.floor(seconds / secondsInAMin);
				return minutes + 'm';
			} else {
				return seconds + 's';
			}
		},

		getTimeUnit: function(value) {
			if (value.indexOf('d') > 0) {
				return dayStr;
			} else if (value.indexOf('h') > 0) {
				return hourStr;
			} else if (value.indexOf('m') > 0) {
				return minuteStr;
			}
		}
	});

});

